<template>
  <div class="flex w-full flex-col gap-2">
    <h3 class="text-lg font-semibold">Ordens</h3>
    <div class="overflow-y-auto rounded-lg">
      <table class="w-full text-sm">
        <!-- HEADER -->
        <ontick-table-head-component :headers="headers" />

        <!-- BODY -->
        <tbody class="dark:bg-ontick-graphite-500 bg-ontick-steel-100 text-xs">
          <tr v-for="order in orders" :key="order.order_id">
            <td>
              <div>
                {{ order.strategy_name }}
              </div>
            </td>
            <td>
              <div>
                <ontick-symbol-pill-component :symbol="order.order_symbol" />
              </div>
            </td>
            <td>
              <div>
                <ontick-position-pill-component
                  :position_status="directionTranslate(order.order_direction)"
                />
                <span class="font-bold">
                  {{ order.order_volume }}
                </span>
              </div>
            </td>
            <td>
              <div>
                {{ moment(order.order_time).format("DD/MM/YYYY - HH:mm:ss") }}
              </div>
            </td>
            <td>
              <div>
                <div
                  class="bg-ontick-blue-800 rounded px-3 font-bold text-white"
                >
                  {{ order.order_state }}
                </div>
              </div>
            </td>
            <td>
              <div>
                {{ order.order_goal }}
              </div>
            </td>
            <td>
              <div>
                <div
                  class="bg-ontick-prussian-400 rounded px-3 font-bold text-white"
                >
                  {{ order.order_type }}
                </div>
              </div>
            </td>
            <td>
              <div>
                {{ order.order_price }}
              </div>
            </td>
            <td>
              <div>
                {{ order.order_comment }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import OntickPositionPillComponent from "../../../../shared/components/basic/ontick-position-pill.component.vue";
import OntickSymbolPillComponent from "../../../../shared/components/basic/ontick-symbol-pill.component.vue";
import OntickTableHeadComponent from "../../../../shared/components/basic/ontick-table-head.component.vue";

export default {
  components: {
    OntickTableHeadComponent,
    OntickSymbolPillComponent,
    OntickPositionPillComponent,
  },

  props: {
    orders: {
      type: Array,
    },
  },

  data() {
    return {
      headers: [
        {
          label: "Estrategia",
          key: "strategy_name",
        },
        {
          label: "Ativo",
          key: "order_symbol",
        },
        {
          label: "Ordem",
          key: "order_direction",
        },
        {
          label: "Horário",
          ke: "order_time",
        },
        {
          label: "Status",
          key: "order_state",
        },
        {
          label: "Sentido",
          key: "order_goal",
        },
        {
          label: "Tipo",
          key: "order_type",
        },
        {
          label: "Preço",
          key: "order_price",
        },
        {
          label: "Comentário",
          key: "order_comment",
        },
      ],
    };
  },

  methods: {
    directionTranslate(direction) {
      switch (direction) {
        case "Compra":
          return "Comprado";
        case "Venda":
          return "Vendido";
        default:
          return direction;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
th {
  @apply text-left;
}
td {
  @apply gap-1 py-2 px-4 text-gray-600 dark:text-gray-400;
  & > div {
    @apply flex items-center gap-1;
  }
}
</style>
